import type { BlockComponentProps } from "./shared"

export function CalloutBlock({ content, resolved }: BlockComponentProps) {
  const coType = (content?.type as "info" | "tip" | "warning" | "success") ?? "info"
  const coH = (content?.heading as string) ?? ""
  const coB = (content?.body as string) ?? ""
  const variantStyles = {
    info: "border-blue-500/50 bg-blue-50 dark:bg-blue-950/30",
    tip: "border-green-500/50 bg-green-50 dark:bg-green-950/30",
    warning: "border-amber-500/50 bg-amber-50 dark:bg-amber-950/30",
    success: "border-green-500/50 bg-green-50 dark:bg-green-950/30",
  }
  const calloutSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-4"} ${resolved.cornerClass} ${resolved.alignClass} max-w-2xl mx-auto`.trim()
    : "px-4 py-4 @sm:px-6 @md:px-8 max-w-2xl mx-auto"
  return (
    <section className={calloutSectionClass} style={resolved.sectionStyle}>
      <div className={`rounded-lg border-l-4 p-4 ${variantStyles[coType]}`}>
        {coH && <p className="font-semibold mb-1">{coH}</p>}
        {coB && <p className="text-sm text-muted-foreground">{coB}</p>}
      </div>
    </section>
  )
}
